/* Fransk katalog for locale-advisor-costs-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'adv.cost.review': 'Examiner',
  'adv.cost.moreTitle': 'Autres opportunités',
  'adv.cost.observedValue': 'Valeur observée',
  'adv.cost.invoiceBasis': 'Base de facturation',
  'adv.cost.draftValue': 'Valeur des brouillons',
  'adv.cost.possibleCount': 'Doublons possibles',
  'adv.cost.purchaseShare': 'Part des achats',
  'adv.cost.givenDiscount': 'Remise accordée',
  'adv.cost.unbilledNote': 'Base de facturation, pas un produit comptabilisé',
  'adv.cost.draftNote': 'Valeur des brouillons, pas un produit comptabilisé',
  'adv.cost.acceptedNote': 'Devis acceptés sans facture associée',
  'adv.cost.duplicateNote': 'Doublons possibles à vérifier',
  'adv.cost.supplierNote': 'Volume d\'achats pouvant servir de base à une négociation',
  'adv.cost.discountTitle': 'Passer en revue les remises accordées',
  'adv.cost.discountNote': 'Remises effectivement accordées, pas une économie estimée',
  'adv.cost.voucherNote': 'Documentation à suivre ; aucune économie estimée',
  'adv.cost.followUp': 'À suivre',
  'adv.cost.increaseToReview': 'Hausse à examiner',
  'adv.cost.fixedTitle': 'Charges fixes comptabilisées',
  'adv.cost.tryAdjustment': 'Essayer un ajustement',
  'adv.cost.fixedDetail': 'Moyenne mensuelle, basée sur {months} mois complets',
  'adv.cost.otherTitle': 'Principaux autres comptes de charges',
  'adv.cost.otherIntro': 'La part compare les charges comptabilisées au chiffre d\'affaires de l\'année sélectionnée. Ce n\'est pas une estimation d\'économie, et le compte n\'est pas automatiquement classé comme variable.',
  'adv.cost.otherDetail': '{amount} comptabilisés sur l\'année sélectionnée',
  'adv.cost.ofRevenue': 'du chiffre d\'affaires',
  'adv.cost.noRevenueShare': 'Part non calculée',
  'adv.cost.sub': 'Principaux comptes de charges comptabilisés et évolution par rapport à l\'année précédente',
  'adv.cost.subPeriod': 'Principaux comptes de charges comptabilisés et évolution par rapport à la même période l\'an dernier',
  'adv.cost.help': 'Les comptes proviennent du compte de résultat de l\'année sélectionnée. Les barres indiquent le montant comptabilisé par compte. L\'évolution n\'est affichée que si le même compte présente un montant positif l\'année précédente.',
  'adv.cost.helpPeriod': 'Les comptes proviennent du compte de résultat jusqu\'au mois en cours inclus. Les barres indiquent le montant comptabilisé par compte. L\'évolution est comparée à la même période l\'an dernier lorsque le compte présentait un montant positif.',
  'adv.cost.rowHelp': 'Comptabilisé sur le compte : {amount} sur l\'année sélectionnée. Évolution par rapport à l\'année précédente : {change}.',
  'adv.cost.noComparison': 'Pas de chiffres de l\'année précédente',
  'adv.cost.emptyText': 'Aucun compte de charges comptabilisé sur l\'année sélectionnée.',
  'adv.cost.flagText': '{name} a nettement augmenté par rapport à l\'année précédente. Vérifiez si cette évolution était prévue et passez en revue les écritures du compte.',
  'adv.why.costSub': 'Comptes de charges qui ont nettement augmenté par rapport à l\'année précédente',
});
